<template>
  <HoverTooltip>
    <div class="status-container">
      <div
        class="status-item first"
        :style="{
          backgroundColor: colors[getColorByRange(type, values[15])].light,
        }"
      >
        <v-icon
          :color="colors[getColorByRange(type, values[15])].dark"
          :size="iconSize"
          >{{ icons.mdiCircle }}
        </v-icon>
        {{ formatCwvMetric(values[15], type) }}
      </div>
      <!--      <div-->
      <!--        class="status-item"-->
      <!--        :style="{-->
      <!--          backgroundColor: colors[getColorByRange(type, values[17])].light,-->
      <!--        }"-->
      <!--      >-->
      <!--        <v-icon-->
      <!--          :color="colors[getColorByRange(type, values[17])].dark"-->
      <!--          :size="iconSize"-->
      <!--          >{{ icons.mdiCircle }}</v-icon-->
      <!--        >-->
      <!--        {{ formatCwvMetric(values[17], type) }}-->
      <!--      </div>-->
      <div
        class="status-item last"
        :style="{
          backgroundColor: colors[getColorByRange(type, values[16])].light,
        }"
      >
        <v-icon
          :color="colors[getColorByRange(type, values[16])].dark"
          :size="iconSize"
          >{{ icons.mdiCircle }}
        </v-icon>
        {{ formatCwvMetric(values[16], type) }}
      </div>
    </div>
    <template v-slot:tooltip>
      <StatusTooltip :type="type" :values="values" />
    </template>
  </HoverTooltip>
</template>

<script>
import { ref } from "@vue/composition-api";
import HoverTooltip from "@/components/common/HoverTooltip.vue";
import StatusTooltip from "@/components/web-perf/cwv/cwv-sites-performance/cards/StatusTooltip.vue";
import {
  mdiCellphone,
  mdiTablet,
  mdiMonitor,
  mdiCircle,
  mdiCircleOutline,
} from "@mdi/js";
import { ranges, formatCwvMetric } from "@/components/web-perf/cwv/utils/utils";

export default {
  name: "StatusCard",
  components: {
    HoverTooltip,
    StatusTooltip,
  },
  props: {
    type: String,
    values: Object,
  },
  setup(props) {
    const hover = ref(false);
    const isVisible = ref(false);
    const cursorX = ref(0);
    const cursorY = ref(0);
    const inactivityTimer = ref(null);

    const iconSize = 18;

    const colors = {
      red: {
        light: "#ffdfdd",
        dark: "#f44335",
      },
      orange: {
        light: "#feddaa",
        dark: "#ff9800",
      },
      green: {
        light: "#e3ffc3",
        dark: "#8bc34a",
      },
      blue: {
        light: "#e3e3ff",
        dark: "#6171cb",
      },
    };

    const icons = {
      mdiCellphone,
      mdiTablet,
      mdiMonitor,
      mdiCircle,
      mdiCircleOutline,
    };

    function getColorByRange(metric, value) {
      const range = ranges[metric];
      if (!value) {
        return "blue";
      }
      if (value <= range[0]) {
        return "green";
      } else if (value <= range[1]) {
        return "orange";
      } else {
        return "red";
      }
    }

    return {
      hover,
      isVisible,
      cursorX,
      cursorY,
      inactivityTimer,
      iconSize,
      colors,
      icons,
      formatCwvMetric,
      getColorByRange,
    };
  },
};
</script>
<style lang="scss" scoped>
.status-container {
  display: inline-flex;
  overflow: hidden;
  border-radius: 16px;
  font-size: 12px;
  color: black;
}

.status-item {
  display: flex;
  align-items: center;
  padding: 5px 10px;
  gap: 5px;
}

/* Fix the border radius issue */
//.first {
//border-radius: 20px 0 0 20px;
//}

//.last {
//border-radius: 0 20px 20px 0;
//}
</style>
